import { render, staticRenderFns } from "./TabelaResultadosConveniosUsuario.vue?vue&type=template&id=32e2d1fc&scoped=true&"
import script from "./TabelaResultadosConveniosUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosConveniosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosConveniosUsuario.vue?vue&type=style&index=0&id=32e2d1fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2d1fc",
  null
  
)

export default component.exports